import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { material } from '../../../library/material';
import Snackbar from '../../toastrmessage/Snackbar';
import { saveCosmeticTreatmentMaster } from '../../../services/TreatmentListService';

function AddMasterTreatmentData(props) {
    const { register, handleSubmit, reset } = useForm({ mode: "onTouched" });
    const { openAddTreatmentDialog, setOpenAddTreatmentDialog, userDetails, clinicDetails, getMasterTreatmentList } = props;
    const [openSnackBar, setOpenSnackBar] = useState({
        "action": false,
        "type": "",
        "message": "",
    });

    useEffect(() => {
        if (openAddTreatmentDialog.rowData) {
            reset(openAddTreatmentDialog.rowData)
        }
    }, [openAddTreatmentDialog.action]);

    const saveTreatment = (data) => {
        const payload = {
            treatmentId: openAddTreatmentDialog.rowData ? openAddTreatmentDialog.rowData.treatmentId : "",
            orgId: userDetails.orgId,
            clinicId: clinicDetails.clinicId,
            treatmentName: data.treatmentName
        }
        saveCosmeticTreatmentMaster(payload)
            .then((resp) => {
                setOpenSnackBar({
                    "action": true,
                    "type": "success",
                    "message": resp.data.messages,
                })
                reset({ treatmentName: "" });
                getMasterTreatmentList();
                setOpenAddTreatmentDialog({ action: false, rowData: null });
            })
            .catch((error) => {
                const errorMessage =
                    error.response?.data?.data?.info ||
                    error.response?.data?.data ||
                    error.response?.data?.messages ||
                    "An unexpected error occurred";

                setOpenSnackBar({
                    action: true,
                    type: "error",
                    message: errorMessage,
                });
            })
    };

    const handleClose = () => {
        reset({ treatmentName: "" });
        setOpenAddTreatmentDialog({ action: false, rowData: null })
    };

    return (
        <div>
            <material.Dialog open={openAddTreatmentDialog.action} maxWidth="sm" fullWidth>
                <material.DialogTitle>{openAddTreatmentDialog.rowData == null ? "Add Master Treatment" : "Edit Master Treatment"}</material.DialogTitle>
                <material.DialogContent>
                    <material.TextField
                        required
                        fullWidth
                        variant="standard"
                        label="Treatment Name"
                        type='text'
                        {...register("treatmentName", { required: true })}
                    />
                </material.DialogContent>
                <material.DialogActions>
                    <material.Button onClick={handleClose} variant="outlined" sx={{ textTransform: "none" }} color='error' startIcon={<material.CloseIcon />}>Cancel</material.Button>
                    <material.Button onClick={handleSubmit(saveTreatment)} variant="outlined" sx={{ textTransform: "none" }} startIcon={<material.DoneIcon />}>{openAddTreatmentDialog.rowData == null ? "Save" : "Update"}</material.Button>
                </material.DialogActions>
            </material.Dialog>
            <Snackbar
                openSnackBar={openSnackBar}
                setOpenSnackBar={setOpenSnackBar}
            />
        </div>
    );
}

export default AddMasterTreatmentData;